import { useNavigate } from '@reach/router'
import { useNotification } from '@btime/react-messager'
import { useLoggedUser, useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormInitialStateFromFilter } from './../_helpers/formStateFromFilter'
import { useOpenEditServiceOrderModal } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'
import { useConfig } from '../../../containers/configs/_load/ConfigsLoader'
import { useSaveServiceOrder } from '../_requests/saveServiceOrder'

const AddNewButton = () => {
  const { t } = useTranslation('processes')
  const hasAddLeanServiceOrderPermission = useSessionPermission('createLeanServiceOrder')
  const leanServiceOrder = useConfig('lean_service_order')
  const fastServiceOrder = useConfig('fast_service_order')
  const loggedUser = useLoggedUser()

  const leanServiceOrderState = hasAddLeanServiceOrderPermission
    ? {
        place: leanServiceOrder?.value?.place,
        userOrGroup: leanServiceOrder?.value?.userOrGroup || loggedUser
      }
    : {}

  const hasAddPermission = useSessionPermission('createServiceOrder')
  const openModal = useOpenEditServiceOrderModal()
  const getState = useFormInitialStateFromFilter()

  const [onSubmit, { loading }] = useSaveServiceOrder()
  const navigate = useNavigate()
  const notify = useNotification()

  const fastServiceOrderAction = (fastServiceOrder, loggedUser) => {
    const onSuccess = record => navigate(`/service-orders/${record?.id}/execution`)
    const onError = () => notify.error({ title: t('processes.error.createActivity') })
    onSubmit(
      {
        checklistId: fastServiceOrder?.value?.checklistId,
        placeId: fastServiceOrder?.value?.placeId,
        userId: loggedUser?.id
      },
      { onSuccess, onError }
    )
  }

  if (!hasAddPermission) return false

  return (
    <FixedRoundButton
      loading={loading}
      onClick={() =>
        fastServiceOrder
          ? fastServiceOrderAction(fastServiceOrder, loggedUser)
          : openModal({ initialState: { ...getState(), ...leanServiceOrderState } })
      }
    />
  )
}

export default AddNewButton
